import React from 'react';
import styled from '@emotion/styled';
import { useT } from 'client/i18n/hooks/useT';
import { CarouselTypeProps } from '../types';
import { SCREEN_BREAKPOINTS } from '../../../constants';

const CarouselAdTypeElement = styled.p`
  margin: 50px 0 15px;
  padding: 0 8%;
  color: #ffffff;
  font-size: 1.125rem;
  line-height: 1.75rem;
  span {
    font-weight: bold;
  }
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    margin: 26px 0 10px;
    padding: 0;
    font-size: 0.875rem;
    line-height: 1.125rem;
  }
`;

const CarouselAdTypeDescription = styled(CarouselAdTypeElement)`
  margin-top: 14px;
`;

export const CarouselType = ({ adType }: CarouselTypeProps) => {
  const t = useT();
  return (
    <div>
      <CarouselAdTypeElement>{adType.getType(t)}</CarouselAdTypeElement>
      <CarouselAdTypeDescription>
        {adType.getDescription(t)}
      </CarouselAdTypeDescription>
    </div>
  );
};
